import { PTOStatus } from '@/types/api';
import * as Styles from './PTORequestWarnings.styles';
import {
  ptoRequestTextColorsMapping,
  PTORequestWarningType,
  ptoRequestWarningIconsMapping,
  ptoRequestWarningTextMapping,
} from './PTORequestWarnings.utils';

type PTORequestWarningsComponentProps = {
  status: PTOStatus;
  overlapping?: boolean;
  notEnoughHours?: boolean;
};

const PTORequestWarningsComponent = function ({
  status,
  overlapping = false,
  notEnoughHours = false,
}: PTORequestWarningsComponentProps): JSX.Element {
  const warnings: PTORequestWarningType[] = [];

  if (notEnoughHours) warnings.push('NOT_ENOUGH_HOURS');
  if (overlapping) warnings.push('OVERLAPPING_REQUEST');

  if (status === PTOStatus.APPROVED) warnings.push('REQUEST_APPROVED');
  else if (status === PTOStatus.DENIED) warnings.push('REQUEST_DENIED');

  return (
    <Styles.Warnings>
      {warnings.map((warning) => (
        <Styles.WarningItem key={warning}>
          <Styles.Icon>{ptoRequestWarningIconsMapping[warning]}</Styles.Icon>
          <Styles.Description $color={ptoRequestTextColorsMapping[warning]}>
            {ptoRequestWarningTextMapping[warning]}
          </Styles.Description>
        </Styles.WarningItem>
      ))}
    </Styles.Warnings>
  );
};

export default PTORequestWarningsComponent;
